import { render, staticRenderFns } from "./AddKnowitDialog.vue?vue&type=template&id=0fee607d"
import script from "./AddKnowitDialog.vue?vue&type=script&lang=js"
export * from "./AddKnowitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports